import { render, staticRenderFns } from "./baohuoProtocol.vue?vue&type=template&id=5fde3552&scoped=true&"
import script from "./baohuoProtocol.vue?vue&type=script&lang=js&"
export * from "./baohuoProtocol.vue?vue&type=script&lang=js&"
import style0 from "./baohuoProtocol.vue?vue&type=style&index=0&id=5fde3552&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fde3552",
  null
  
)

export default component.exports